import React, { useState } from 'react';
import PrivacyPolicy from '../legal/PrivacyPolicy';
import TermsOfUse from '../legal/TermsOfUse';

export default function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  return (
    <>
      <footer className="bg-black py-8 mt-auto">
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            {/* Copyright text */}
            <div className="text-sm text-gray-300">
              © 2025 all rights reserved. Made by{' '}
              <a 
                href="https://www.veipha.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-cling-pink"
              >
                veipha
              </a>
            </div>
            
            {/* Legal links */}
            <div className="flex items-center gap-6">
              <button
                onClick={() => setShowPrivacy(true)}
                className="text-sm text-gray-300 hover:text-white"
                type="button"
              >
                Privacy Policy
              </button>
              <span className="text-gray-600">•</span>
              <button
                onClick={() => setShowTerms(true)}
                className="text-sm text-gray-300 hover:text-white"
                type="button"
              >
                Terms of Use
              </button>
            </div>
          </div>
        </div>
      </footer>

      <PrivacyPolicy isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} />
      <TermsOfUse isOpen={showTerms} onClose={() => setShowTerms(false)} />
    </>
  );
}